export default "__VITE_ASSET__5b8bd115__"